
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRainColour as ObiRainColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rain-colour.js';
 
 
 

 
 export const ObiRainColour = createComponent({
   react: React,
   tagName: 'obi-rain-colour',
   elementClass: ObiRainColourElement,
   events: {
     
   }
  });
 
 